<template>
  <span>
    <v-icon @click.stop="dialogClicked()">delete</v-icon>
    <v-dialog v-model="dialog" width="500">
      <v-card class="rounded-lg">
        <v-card-title color="white" primary-title>
          <v-icon color="primary">delete</v-icon>
          <span class="primary--text text--darken-3 title pl-2"
            >Delete Group</span
          >
        </v-card-title>

        <v-card-text class="primary primary--text text--lighten-5 pt-4">
          Are you sure you want to delete group<br />
          '{{ group.name }}'?
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="dialog = false">
            <v-icon left>close</v-icon> Cancel
          </v-btn>

          <v-btn color="error" @click="deleteGroup">
            <v-icon left>delete</v-icon> Delete Group</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    group: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    dialog: false,
  }),
  computed: {},
  methods: {
    async deleteGroup() {
      if (this.group == null) return;
      let group_url = `/api/groups/${this.group.id}`;
      axios.delete(group_url).then(({ _data }) => {
        this.$emit('groupDeleted', true);
        this.dialog = false;
      });
    },
    dialogClicked() {
      this.dialog = !this.dialog;
    },
  },
};
</script>

<style lang="scss" scoped></style>
